import { Typography } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React, { memo } from 'react';
import { Validation } from './CreatePasswordField';
import { useValidationStyles } from './styles';

type Props = {
  validation: Validation;
  text: string;
};

const ValidationItem: React.FC<Props> = ({ validation, text }) => {
  const classes = useValidationStyles();

  if (validation === 'valid') {
    return (
      <li className={`checked ${classes.valid}`}>
        <CheckCircleOutlineIcon />
        <Typography variant="body1">{text}</Typography>
      </li>
    );
  }
  if (validation === 'invalid') {
    return (
      <li className={`checked ${classes.invalid}`}>
        <ErrorOutlineIcon />
        <Typography variant="body1">{text}</Typography>
      </li>
    );
  }
  return (
    <li>
      <Typography variant="body1">{text}</Typography>
    </li>
  );
};

export default memo(ValidationItem);
